import nlnAxios from "../../../api/nlnAxios";


//Create Resources

// const token = JSON.parse(sessionStorage.getItem("nln-virtual-library-user-token"));
// token
const createResources = async (formData, ) => {


const token = JSON.parse(sessionStorage.getItem("nln-virtual-library-user-token"));
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
            
    }
}

    const response = await nlnAxios.post("/library/resources", formData, config);
// =======
//     const response = await nlnAxios.post("/library/resources", formData, {
//         'Content-Type': 'multipart/form-data'
//     });
// >>>>>>> main

    return response.data;
}

//Get Resources

const getResources = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
    }
}

    const response = await nlnAxios.get("/library/public/resources/?resourceType=internal&recentlyCreated=true");

    return response.data;
}

const editResource = async (formData, token) => {

    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //         'Content-Type': 'multipart/form-data'
    //     }
    // }

    const response = await nlnAxios.patch(`/library/resources/${formData.resourceId}`, formData);

    return response.data;
}

const getAllResources = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/resources/?archived=false");

    return response.data;
}


const getResourceByNLN = async (resourceNlnCode, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}
    const response = await nlnAxios.get("/library/public/resources/" + resourceNlnCode );

    return response.data;
}


//Delete resource category 
const deleteResources = async (resourceId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }

    }

    const response = await nlnAxios.delete("/library/resources/" + resourceId);

    return response.data;
}



const resourceService = {
    createResources,
    editResource,
    getAllResources,
    getResources,
    getResourceByNLN,
    deleteResources
}

export default resourceService;